(function () {
  function initGalleryZoom(gallery) {
    var configEl = gallery.querySelector('[data-gallery-zoom-config]');
    if (!configEl) return;

    var images;
    try {
      images = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }
    if (!images || !images.length) return;

    var lightbox = new PhotoSwipeLightbox({
      dataSource: images,
      pswpModule: PhotoSwipe,
      bgOpacity: 0.95,
      showHideAnimationType: 'zoom',
    });
    lightbox.init();

    var items = gallery.querySelectorAll('[data-image-index]');
    items.forEach(function (item) {
      item.classList.add('product-main-gallery__item--zoomable');
      item.addEventListener('click', function () {
        var index = parseInt(item.dataset.imageIndex, 10);
        if (isNaN(index)) return;
        lightbox.loadAndOpen(index);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof PhotoSwipeLightbox === 'undefined' || typeof PhotoSwipe === 'undefined') return;
    document.querySelectorAll('product-gallery').forEach(initGalleryZoom);
  });
})();
